export default __webpack_public_path__ + "static/media/inscriptions.0e02ab4e.png";